// extracted by mini-css-extract-plugin
export default {"price":"bja-z","onSale":"cja-z","msrpLabelPrice":"dja-z","msrpLabel":"eja-z","originalPrice":"fja-z"};